import { useContext } from "react"
import {
  AuthenticationContext,
  AuthenticationProps,
} from "components/Molecules/Authentication"
import { registrationModules } from "types/modules.types"
// Gives the details about the current authenticated user
const useAuth = () => useContext(AuthenticationContext)

// Use Current Department
// As it is the most common use case of the useAuth hook
// it is extracted over here for ease of access
export const useCurrentDepartment = () => {
  const { user } = useContext(AuthenticationContext)
  // The empty string is required else the code may break somewhere
  return user?.currentDepartment?.id ?? ""
}
export default useAuth

// Hook required to get all the ecommerge departments
export const useDeptFrontend = () => {
  const { user } = useContext(AuthenticationContext)

  return user?.currentDepartment?.access?.codename === "ECOM"
}

export const useFormDisabled = (type?: registrationModules, entity?: any) => {
  const { permissions, user } = useAuth()

  let disabled = true
  if (user?.isSuperadmin) {
    disabled = false
  } else if (entity?.id && parseInt(entity?.id)) {
    disabled = !permissions?.find(p => p?.includes(`ds_edit_${type}`))
  } else {
    disabled = !permissions?.find(p => p?.includes(`ds_add_${type}`))
  }

  return disabled
}

export const getFormDisabled = (
  auth: AuthenticationProps,
  type: registrationModules,
  entity?: any
) => {
  const { permissions, user } = auth

  let disabled = true
  if (user?.isSuperadmin) {
    disabled = false
  } else if (entity?.id && parseInt(entity?.id)) {
    disabled = !permissions?.find(p => p?.includes(`ds_edit_${type}`))
  } else {
    disabled = !permissions?.find(p => p?.includes(`ds_add_${type}`))
  }

  return disabled
}

export const useAuthorizationModules = (
  accessType:
    | "edit"
    | "edit_previous"
    | "add"
    | "delete"
    | "delete_previous"
    | "view"
    | "add_previous",
  module: registrationModules
) => {
  const { permissions, user } = useAuth()

  let disabled = true
  if (user?.isSuperadmin) {
    disabled = false
  } else {
    disabled = !permissions?.find(p =>
      p?.includes(`ds_${accessType}_${module}`)
    )
  }
  return disabled
}
